<template>
  <div>
    <h2>
        Viatics ...
    </h2>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>